module.exports = __webpack_public_path__ + "static/media/imb.70744ba5.png";